module.exports = require('./helpers/bundle-url').getBundleURL('4afSR') + "browse.04f9b2c2.png";